/*
  MSIS-29 section ids
 */

export default {
  msLimits: ['physicalActivity', 'grip', 'carrying'],
  bothers: [
    'balance',
    'movingIndoors',
    'clumsiness',
    'stiffness',
    'limbHeaviness',
    'limbTremors',
    'limbSpasms',
    'bodyNotDoingWhatYouWant',
    'havingToDependOnOthers',
    'limitationsInHomeActivities',
    'stuckAtHome',
    'difficultiesUsingHands',
    'cutDownOnDailyActivitiesTime',
    'problemsUsingTransports',
    'takingLongerToDoThings',
    'difficultyDoingSpontaneusThings',
    'urgentToiletVisits',
    'feelingUnwell',
    'problemsSleeping',
    'mentallyFatigued',
    'msWorries',
    'feelingAnxiousOrTense',
    'feelingIrritable',
    'problemsConcentrating',
    'lackOfConfidence',
    'feelingDepressed',
  ],
};

export const historySections = {
  physical: [
    'physicalActivity',
    'grip',
    'carrying',
    'balance',
    'movingIndoors',
    'clumsiness',
    'stiffness',
    'limbHeaviness',
    'limbTremors',
    'limbSpasms',
    'bodyNotDoingWhatYouWant',
    'havingToDependOnOthers',
    'limitationsInHomeActivities',
    'stuckAtHome',
    'difficultiesUsingHands',
    'cutDownOnDailyActivitiesTime',
    'problemsUsingTransports',
    'takingLongerToDoThings',
    'difficultyDoingSpontaneusThings',
    'urgentToiletVisits',
  ],
  mental: [
    'feelingUnwell',
    'problemsSleeping',
    'mentallyFatigued',
    'msWorries',
    'feelingAnxiousOrTense',
    'feelingIrritable',
    'problemsConcentrating',
    'lackOfConfidence',
    'feelingDepressed',
  ],
};
